import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PrivacyPolicyVersionMatch} from '../privacy-policy-state';
import {
  readReloadCount,
  RELOAD_ATTEMPTS_BEFORE_SUPPORT_HINT,
} from '../privacy-policy-reload-count';


/**
 * Weist darauf hin, dass die angezeigte Datenschutzerklärung nicht die geltende Fassung ist.
 *
 * Der Zustand kommt von außen herein, damit die Komponente keinen Dienst kennen muss: Nur der
 * Einbinder kennt den geladenen Kontext und die Antwort des Servers auf eine Zustimmung.
 *
 * Der Hinweis erscheint als Einblendung über dem Text, nicht als weiterer Dialog: Die Schranke ist
 * selbst schon ein Dialog mit disableClose, ein zweiter darüber brächte Fokusfallen mit sich, und
 * die freie Ansicht hätte gar keinen, in den er sich einhängen könnte.
 */
@Component({
  selector: 'app-version-notice',
  templateUrl: './version-notice.component.html',
  styleUrls: ['./version-notice.component.scss'],
})
export class VersionNoticeComponent {

  dismissed = false;

  private match_: PrivacyPolicyVersionMatch = 'matches';

  @Input()
  set match(value: PrivacyPolicyVersionMatch) {
    this.match_ = value;
    if (value === 'matches') {
      this.dismissed = false;
    }
  }

  get match(): PrivacyPolicyVersionMatch {
    return this.match_;
  }

  get deviates(): boolean {
    return this.match_ === 'deviates';
  }

  get showSupportHint(): boolean {
    return readReloadCount() >= RELOAD_ATTEMPTS_BEFORE_SUPPORT_HINT;
  }

  dismiss(): void {
    this.dismissed = true;
  }

  reopen(): void {
    this.dismissed = false;
  }

  /**
   * Meldet den Wunsch nach einem Neuladen, statt es selbst auszulösen: Ein Hinweis, der von sich
   * aus die Anwendung neu lädt und dabei einen Zähler fortschreibt, lässt sich nirgends mehr
   * zeigen, ohne beides auszulösen - auch nicht im Test.
   */
  @Output()
  reloadRequested = new EventEmitter<void>();

  reload(): void {
    this.reloadRequested.emit();
  }
}
